import { tripleWhale } from "utils/triple-whale";

// Fires a Triple Whale "Contact" event once the user's email is known, so the
// Triple Pixel can connect the events in the customer's journey. This mirrors
// the Impact `identify` flow in ./impact.js and triggers at the same point.

// track the last email we sent so we only fire the Contact event once per email
let lastSentEmail = null;

// eslint-disable-next-line
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const tripleWhaleMiddleware = store => next => action => {
    const result = next(action);

    const state = store.getState();

    const email = state.user?.userData?.email || action?.payload?.tracking_email;

    if (email && email !== lastSentEmail && EMAIL_REGEX.test(email)) {
        lastSentEmail = email;
        tripleWhale('Contact', { email });
    }

    // pass the dispatch result through, or thunk/promise actions dispatched
    // through this middleware stop being awaitable
    return result;
};
